var map = {
	"./雕刻激光/50cm泡沫雕吸.jpg": 5051,
	"./雕刻激光/亚克力制品.jpg": 5640,
	"./雕刻激光/亚克力制品1.jpg": 879,
	"./雕刻激光/亞克力制品.jpg": 9292,
	"./雕刻激光/亞克力貨架.jpg": 6229,
	"./雕刻激光/信箱.jpg": 9001,
	"./雕刻激光/實心鋁雕刻.jpg": 4849,
	"./雕刻激光/木板蚀刻牌.jpg": 8739,
	"./雕刻激光/木板雕刻牌.jpg": 8202,
	"./雕刻激光/蝕刻烤漆.jpg": 3645,
	"./雕刻激光/蝕刻牌.jpg": 7683,
	"./雕刻激光/雕刻字.jpg": 3772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8074;